const getCurrentDrawerState = () => {
  const documentElement = document.documentElement;

  if (documentElement.classList.contains('cart-expanded')
      || documentElement.classList.contains('nav-expanded')) {
    return 'open';
  }

  return 'closed';
};

export default getCurrentDrawerState;
